import { gql } from '@apollo/client';

/**
 * 站点拆分（#5）：新站点已由 saveCooperationWarehouse 建好，本 mutation 迁移选中关联地址 relate 行到新站点、
 * 逻辑删主揽收地址在原站点的旧 relate。对应 api-server PickupStationMaintainMutation.resolveStationSplit。
 */
export const RESOLVE_STATION_SPLIT = gql`
  mutation ResolveStationSplit($input: SplitStationInput!) {
    resolveStationSplit(input: $input)
  }
`;

export interface SplitStationInput {
  /** 拆分新建的站点 id（先经 saveCooperationWarehouse 创建）。 */
  newCooperationWarehouseId: number;
  /** 拆出的其他关联地址 relate id（改属新站点）。 */
  movedRelateIds: number[];
  /** 主揽收地址在原站点的旧 relate id（逻辑删；可空）。 */
  primaryOldRelateId?: number | null;
}

export interface ResolveStationSplitResponse {
  resolveStationSplit: boolean;
}
